import { useState } from "react";
import { useTranslation } from "react-i18next";
import { joinWaitlist } from "../api/waitlist";
import { ApiError } from "../api/client";
import { primaryBtn, inputStyle, errorStyle } from "../styles";

interface Props {
  /** Where this form is rendered — goes straight into WaitlistSignup.source for the funnel. */
  source: string;
}

export default function WaitlistForm({ source }: Props) {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      setError(t("waitlist.errors.emailRequired"));
      return;
    }
    setError("");
    setSubmitting(true);
    try {
      await joinWaitlist(email.trim(), source);
      setSubmitted(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t("waitlist.errors.failed"));
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <p style={{ color: "var(--color-success)", fontSize: "0.9rem", marginTop: "1rem" }}>
        {t("waitlist.success")}
      </p>
    );
  }

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: "1rem", textAlign: "left" }}>
      <label htmlFor="waitlist-email" style={{
        display: "block", fontSize: "0.65rem", fontWeight: 700, textTransform: "uppercase",
        letterSpacing: "0.12em", color: "var(--color-text-dim)", marginBottom: "0.5rem",
      }}>
        {t("waitlist.emailLabel")}
      </label>
      <input
        id="waitlist-email"
        type="email"
        placeholder={t("waitlist.emailPlaceholder")}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ ...inputStyle, marginBottom: "0.5rem", width: "100%" }}
        autoComplete="email"
      />
      {error && <p style={errorStyle}>{error}</p>}
      <button type="submit" disabled={submitting} style={{ ...primaryBtn, width: "100%" }}>
        {submitting ? t("common.saving") : t("waitlist.joinCta")}
      </button>
    </form>
  );
}
